import toastr from 'toastr'

import { Button } from '@/shared/ui/Button'

import { enableDebugPanel, isDebugPanelDisabled } from './storage'
import { useDebugPanelEligible } from './useDebugPanelEligible'

export function DebugPanelProfileSettings() {
  const eligible = useDebugPanelEligible()

  if (!eligible) return null

  const disabled = isDebugPanelDisabled()

  const handleReEnable = () => {
    enableDebugPanel()
    toastr.success('Painel de debug reativado')
    window.location.reload()
  }

  return (
    <div className="flex w-full flex-col">
      <label className="mb-1 block text-base font-medium text-gray-900">
        Ferramentas de desenvolvimento
      </label>
      <p className="mb-3 text-sm text-gray-700">
        Painel flutuante para depuração em WebView e produção (equipe TTZ).
      </p>
      {disabled ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="self-start"
          data-testid="debug-panel-profile-reenable"
          onClick={handleReEnable}
          showTrailingIcon={false}
        >
          Reativar painel de debug
        </Button>
      ) : (
        <span className="text-sm text-gray-700">
          Painel ativo — use &quot;Desativar painel&quot; no FAB DBG.
        </span>
      )}
    </div>
  )
}
